
    // this file was auto generated by python script
    import Terminal from './Terminal';
    export default Terminal;
    